<template>
  <footer class="app-footer">
    <div class="up-container app-footer__inner">
      <div class="app-footer__top">
        <div class="app-footer__brand">
          <UPlusLogo compact label="UPlus" @click="goHome" />
          <span class="app-footer__version">{{ $t('© 2026 UPlus Technologies. 保留所有權利。') }}</span>
        </div>

        <nav class="app-footer__links" :aria-label="$t('页脚导航')">
          <template v-if="authed">
            <a href="#" @click.prevent="openHelpCenter">
              {{ $t('帮助中心') }}
            </a>
            <a href="#" @click.prevent="openLegal('terms')">
              {{ $t('服务条款') }}
            </a>
            <a href="#" @click.prevent="openLegal('privacy')">
              {{ $t('隐私政策') }}
            </a>
          </template>
          <template v-else>
            <router-link to="/login">{{ $t('登录') }}</router-link>
            <router-link to="/register">{{ $t('注册领点卡') }}</router-link>
          </template>
          <span class="app-footer__status">
            <i aria-hidden="true" />
            {{ $t('系统运行正常') }}
          </span>
        </nav>
      </div>

      <p class="app-footer__risk">
        {{ $t('风险提示：数字资产交易存在较高市场风险，策略历史表现不代表未来收益。请在充分了解产品规则与风险的前提下，根据自身风险承受能力谨慎决策。本页面数据为演示环境模拟数据。') }}
      </p>
    </div>
  </footer>
</template>

<script>
import UPlusLogo from './UPlusLogo.vue'

export default {
  name: 'AppFooter',
  components: { UPlusLogo },
  props: {
    authed: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openLegal(tab) {
      this.$root.$emit('open-legal-terms', tab)
    },
    openHelpCenter() {
      this.$root.$emit('open-help-center')
    },
    goHome() {
      const target = localStorage.getItem('token') ? '/app/overview' : '/'
      if (this.$route.path !== target) this.$router.push(target)
    }
  }
}
</script>

<style scoped>
.app-footer {
  flex: 0 0 auto;
  border-top: 1px solid #e9ebf2;
  background: #fff;
}

.app-footer__inner {
  min-height: 88px;
  padding-top: 15px;
  padding-bottom: 14px;
}

.app-footer__top,
.app-footer__brand,
.app-footer__links,
.app-footer__status {
  display: flex;
  align-items: center;
}

.app-footer__top {
  justify-content: space-between;
  gap: 24px;
}

.app-footer__brand {
  min-width: 0;
  gap: 18px;
}

.app-footer__version {
  color: #8d95a6;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
}

.app-footer__links {
  flex: 0 0 auto;
  gap: 22px;
}

.app-footer__links a {
  color: #667085;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  transition: color .16s ease;
}

.app-footer__links a:hover,
.app-footer__links a:focus-visible {
  color: var(--up-blue);
}

.app-footer__status {
  gap: 9px;
  color: #079455;
  font-size: 13px;
  font-weight: 700;
  line-height: 20px;
  white-space: nowrap;
}

.app-footer__status i {
  width: 6px;
  height: 6px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: #12b76a;
}

.app-footer__risk {
  margin: 11px 0 0;
  color: #98a0af;
  font-size: 12px;
  line-height: 18px;
}

@media (max-width: 900px) {
  .app-footer__inner {
    padding-top: 18px;
    padding-bottom: 18px;
  }

  .app-footer__top {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }

  .app-footer__links {
    width: 100%;
    flex-wrap: wrap;
    gap: 8px 18px;
  }

  .app-footer__status {
    margin-left: auto;
  }
}

@media (max-width: 520px) {
  .app-footer__inner {
    padding-bottom: calc(50px + env(safe-area-inset-bottom));
  }

  .app-footer__brand {
    align-items: flex-start;
    flex-direction: column;
    gap: 5px;
  }

  .app-footer__links {
    justify-content: space-between;
  }

  .app-footer__status {
    width: 100%;
    margin-left: 0;
  }
}
</style>
